import React from 'react';

export interface DescriptionItem {
  label: React.ReactNode;
  value: React.ReactNode;
}

/** Read-only label/value pairs. Replaces "<b>Label</b>: value |" strings. */
const DescriptionList: React.FC<{ items: DescriptionItem[] }> = ({ items }) => (
  <dl className="ds-dl">
    {items.map((item, i) => (
      <div className="ds-dl__item" key={i}>
        <dt>{item.label}</dt>
        <dd>{item.value ?? '—'}</dd>
      </div>
    ))}
  </dl>
);

export default DescriptionList;
